<script type="ts">
	import {currentPageLang, localeStr, PAGE_IS_ABOUT_TO_CHANGE_EVENT, waitLocalesLoaded} from "../render";
	import {checkCookieConsent, setCookieConsent} from "../gtag";
	import {onMount} from "svelte";
	
	let lang = currentPageLang();
	let show = !checkCookieConsent();
	let ready = false;
	
	function okClicked() {
		setCookieConsent();
		show = false;
	}
	
	onMount(() => {
		document.addEventListener(PAGE_IS_ABOUT_TO_CHANGE_EVENT, evt => {
			lang = evt.detail.lang;
		});
		waitLocalesLoaded(() => ready = true);
	});
</script>

{#if show && ready}
	{#key lang}
		<div>
			<div>{localeStr("cookieConsent")}</div>
			<button class="top-button" on:click={okClicked}>{localeStr("ok")}</button>
		</div>
	{/key}
{/if}
